import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../dialogFooter'
import TiposDeRecebimentoTable from '../../views/tiposDeRecebimento/tiposDeRecebimentoTable'
import GeneralServices from '../../app/service/generalServices'
import TiposDeRecebimentoService from '../../app/service/tiposDeRecebimentoService'
import HandleErrorService from '../../app/service/handleErrorService'
import ConstantsUtil from '../../context/constantsUtil'
import { Button } from 'primereact/button'
import AuthService from '../../app/service/authService'
import CadastrarTipoDeRecebimentoSimplesDialog from './cadastrarTipoDeRecebimentoSimplesDialog'

class ChooseTipoDeRecebimentoDialog extends React.Component {

    constructor(){
        super()
        this.tiposDeRecebimentoService = new TiposDeRecebimentoService()
    }

    state = {

        selectedTipoDeRecebimento: '',
        tipoDeRecebimentoList: [],
        filteredTipoDeRecebimentoList: [],

        searchText: '',

        didUpdated: false,

        loading: false,

        displayCadastroTipoDeRecebimentoDialog: false,
        // nomeTipoDeRecebimentoASerCriado: '',
        // inputCreateTipoDeRecebimentoErrorClass: '',

    }

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){
            this.setState({searchText: ''})

            var list = []
            if(!this.props.list || this.props.list.length === 0){
                this.setState({loading: true})
                // this.tiposDeRecebimentoService.searchByContaBancaria(this.props.contaBancariaId)
                this.search(list)
            }
            else{
                list = this.props.list
                this.setState({tipoDeRecebimentoList: list})
                this.setState({filteredTipoDeRecebimentoList: list})
            }

            
            this.setState({didUpdated: true})

        }
    }

    search = (list) => {
        this.tiposDeRecebimentoService.search(true)
        .then(response => {
            list = response.data
            if(this.props.fromOFX){
                //https://trello.com/c/IIKEgIRZ/664-corrigir-tratamento-de-erro-ao-tentar-realizar-lan%C3%A7amento-banc%C3%A1rio-de-dinheiro
                list = list.filter(tipoDeRecebimento => tipoDeRecebimento.natureza !== ConstantsUtil.naturezaTipoDeRecebimentoDinheiroLabel)
            }
            this.setState({tipoDeRecebimentoList: list})
            this.setState({filteredTipoDeRecebimentoList: list})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally( () => {
            this.setState({loading: false})
        } )
    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
        this.filter()
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            const filteredList = JSON.parse(JSON.stringify(this.state.filteredTipoDeRecebimentoList))
            if(filteredList.length === 1){
                await this.setState({selectedTipoDeRecebimento: filteredList[0]})
                this.callSave()
            }
          }
    }

    filter  = () => {
        
        this.setState({
            filteredTipoDeRecebimentoList:
                JSON.parse(
                    JSON.stringify(
                        this.state.tipoDeRecebimentoList.filter(tipoDeRecebimento => {
                            return (
                                GeneralServices.includeString(tipoDeRecebimento.nomeTipoDeRecebimento, this.state.searchText)
                                // tipoDeRecebimento.nomeTipoDeRecebimento.toLowerCase().includes(this.state.searchText.toLowerCase())
                                ||
                                GeneralServices.includeString(tipoDeRecebimento.numeroDeChamada, this.state.searchText)
                                // ((tipoDeRecebimento.id*5).toString().includes(this.state.searchText))
                            ) 
                        }
                        )
                    )
                )
        })
    }

    handleSelectionTipoDeRecebimentoChange = (value) => {
        if(value === null){ //significa que clicou em cima do Tipo de Recebimento que estava selecionado antes
            this.callSave()
        } else{
            this.setState({selectedTipoDeRecebimento: value})
        }
    }

    hideDialog = () => {
        this.setState({didUpdated: false})
        this.props.hideDialog()
    }

    callSave = async () => {
        await this.props.handleSelectionTipoDeRecebimentoChange(this.state.selectedTipoDeRecebimento)
        this.hideDialog()
    }

    // checkDataCreateTipoDeRecebimento = () => {
    //     var check = true
    //     if(!this.state.nomeTipoDeRecebimentoASerCriado){
    //         this.setState({inputCreateTipoDeRecebimentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
    //         check = false
    //     }
    //     return check
    // }

    // callSaveCreateTipoDeRecebimento = () => {
    //     this.setState({inputCreateTipoDeRecebimentoErrorClass: ''})
    //     if(this.checkDataCreateTipoDeRecebimento()){
    //         AuthService.startBlockUi()
    //         this.tiposDeRecebimentoService.createSimples({nomeTipoDeRecebimento: this.state.nomeTipoDeRecebimentoASerCriado})
    //         .then(response => {
    //             this.hideCreateTipoDeRecebimentoDialog()
    //             this.search()
    //         })
    //         .catch(error => {
    //             HandleErrorService.handleError(error)
    //         })
    //         .finally(() => {
    //             AuthService.stopBlockUi()
    //         })
    //     }
    // }

    hideCreateTipoDeRecebimentoDialog = () => {
        this.setState({
            displayCadastroTipoDeRecebimentoDialog: false,
            // nomeTipoDeRecebimentoASerCriado: ''
        })
    }

    render () {

        const chooseTipoDeRecebimentoDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        const renderCadastrarButton = () => {
            // if(this.props.showSimpleCreateButton){
                return (
                    <>
                        <Button
                            label="Cadastrar"
                            icon="pi pi-plus"
                            onClick = {() => this.setState({displayCadastroTipoDeRecebimentoDialog: true})}
                            style={ {maxWidth: '200px' } }
                        />

                        <br />

                        <br />                    
                    </>
                )
            // }
        }

        // const createFooter = (
        //     <DialogFooter save = {this.callSaveCreateTipoDeRecebimento} hideDialog = {this.hideCreateTipoDeRecebimentoDialog}
        //     />
        // )        

        const renderCadastrarDialog = () => {
            return (
                <CadastrarTipoDeRecebimentoSimplesDialog
                    visible={this.state.displayCadastroTipoDeRecebimentoDialog}
                    hideDialog={this.hideCreateTipoDeRecebimentoDialog}
                    search={this.search}
                />
                // <Dialog
                //     visible={this.state.displayCadastroTipoDeRecebimentoDialog}
                //     header={"Cadastrar Tipo de Recebimento Simples"}
                //     modal
                //     style={{ width: '550px' }}
                //     onHide={this.hideCreateTipoDeRecebimentoDialog}
                //     footer={createFooter}                
                // >
                //     <div style={{color: "red", fontSize: "0.8rem"}}>
                //         Ao criar um Tipo de Recebimento por esse atalho, ele será criado com os seguintes parâmetros:
                //         <div style={{marginLeft: '20px', marginBottom: '10px'}}>
                //             <li>Natureza: Outros.</li>
                //             <li>Taxa: 0.</li>
                //             <li>Prazo: 0.</li>
                //             <li>Tipo De Corte: dia do lançamento.</li>
                //         </div>
                //         Caso deseje utilizar outros parâmetros, então crie através do menu Cadastros -&gt; Tipos de Recebimento.
                //     </div>

                //     <br />

                //     <label htmlFor="date">Nome</label>
                //     <input
                //         type="text"
                //         className={"form-control " + this.state.inputCreateTipoDeRecebimentoErrorClass}
                //         value = {this.state.nomeTipoDeRecebimento}
                //         name="nomeTipoDeRecebimentoASerCriado"
                //         onChange={event => this.setState({nomeTipoDeRecebimentoASerCriado: event.target.value})}
                //     />
                //     <div className="invalid-feedback">{"Informe o nome"}</div>                    
                // </Dialog>
            )
        }

        return (
            <>

            <Dialog 
                    visible={this.props.visible}
                    style={{ width: '70vw' }}
                    header={this.props.header}
                    modal
                    className="p-fluid"
                    footer={chooseTipoDeRecebimentoDialogFooter}
                    onHide={this.hideDialog}
            >

                <div className="p-field">
                    <label htmlFor="search conta">Busca</label>
                    <input style={{color: '#000'}}
                        autoFocus   
                        className={"form-control " }
                        type="text"
                        id="searchText"
                        name="searchText"
                        value={this.state.searchText}
                        placeholder="Pesquise pelo nome ou pelo número de chamada"
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress}
                    />
                </div>

                <br />

                {renderCadastrarButton()}

                <TiposDeRecebimentoTable 
                    list = { this.state.filteredTipoDeRecebimentoList }
                    search={this.searchTiposDeRecebimento}
                    nomeTipoDeRecebimentoSearch={this.state.searchText.toUpperCase()}
                    loading={this.state.loading}
                    // push={this.props.history.push}
                    // loading = {this.state.loadingTiposDeRecebimentoTable}
                    simpleView={true}
                    handleSelectionTipoDeRecebimentoChange={this.handleSelectionTipoDeRecebimentoChange}
                />

                {renderCadastrarDialog()}


            </Dialog>
            </>
        )
    }

}

export default ChooseTipoDeRecebimentoDialog